import React from 'react';

const DemoEdgeStatusBadge = ({ status = null, statusClassName = null, onClick = null, role = null, tabIndex = null, ariaLabel = null }) => {
  if (!status) return null;

  const isInteractive = Boolean(onClick);

  return (
    <span
      className={`status-badge${statusClassName ? ` ${statusClassName}` : ''}${isInteractive ? ' status-badge--clickable' : ''}`}
      onClick={onClick}
      role={role || (isInteractive ? 'button' : undefined)}
      tabIndex={tabIndex !== undefined ? tabIndex : isInteractive ? 0 : undefined}
      aria-label={ariaLabel}
    >
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect width="8" height="8" rx="4" fill="currentColor" />
      </svg>
      <span className="label__text">{status}</span>
    </span>
  );
};

export default DemoEdgeStatusBadge;
